import {
  Avatar,
  Box,
  Container,
  Flex,
  Heading,
  Img,
  Link,
  Text,
} from '@chakra-ui/react';
import React from 'react';

const TheAlternativeInvestmentContext: React.FC = () => (
  <>
    <Flex
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height="100%"
      py={{ xs: '30px', sm: '40px', md: '60px', lg: '80px' }}
      h="100%"
      minH={{ xs: '400px', lg: '400px' }}
      maxH={{ xs: '400px', lg: '400px' }}
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/webp/theContext-bg.webp"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        display="flex"
        as="section"
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir={{ xs: 'column', md: 'row' }}
        columnGap="24px"
        rowGap="30px"
        alignItems={{ xs: 'flex-start', md: 'flex-start' }}
        px={{ xs: '14px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Flex flexDir="column" rowGap="16px">
          <Heading
            color="white"
            fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
            fontWeight="800"
            lineHeight={{ xs: '35px', lg: '83px' }}
          >
            #TheContext
          </Heading>
          {/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
        </Flex>
        <Box
          w="1.5px"
          h={{ md: '200px', lg: '300px', xl: '230px' }}
          bgColor="white"
          display={{ xs: 'none', md: 'block' }}
        />
        <Box
          w={{ xs: '70%', sm: '60%' }}
          h="1.5px"
          bgColor="white"
          display={{ xs: 'block', md: 'none' }}
        />
        <Flex flexDir="column" rowGap="8px">
          <Heading
            as="h1"
            mb={{ xs: '10px', md: '20px' }}
            variant="reportCardTitle"
            fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '54px' }}
            color="white"
            lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '70.2px' }}
          >
            Alternative Investment Funds: A Growing Asset Class and a Regulatory
            Balancing Act
          </Heading>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Sushreet Pattanayak
          </Text>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Twinkle Dhamecha
          </Text>
        </Flex>
      </Container>
    </Flex>
    <Container maxW="container.xl" pb="80px" pt="40px">
      <Flex
        flexDir={{ xs: 'column-reverse', md: 'row' }}
        px={{ xs: '8px', md: '0px' }}
      >
        <Flex
          w={{ xs: '100%', md: '27%' }}
          mt={{ xs: '32px', md: '0px' }}
          flexDir="column"
          rowGap="16px"
          mr={{ xs: '0px', md: '40px' }}
          ml={{ xs: '0px', sm: '10px' }}
          mb={{ xs: '16px', md: '8px' }}
        >
          <Heading
            fontSize="22px"
            lineHeight="22px"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            Follow the Authors
          </Heading>
          <Box
            w="100%"
            h="1.5px"
            bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
            my="8px"
          />
          {[
            {
              name: 'Sushreet Pattanayak',
              position: 'Partner, IC Universal Legal',
              image:
                'https://www.ivca.in/_next/image?url=https%3A%2F%2Fspace.levo.so%2FWGLBUT82%2FSushreetPattanayak-Photo-aytLN6LPgAvz.jpg&w=1200&q=75',
            },
            {
              name: 'Twinkle Dhamecha',
              position: 'Partner, IC Universal Legal',
              image:
                'https://www.ivca.in/_next/image?url=https%3A%2F%2Fspace.levo.so%2FWGLBUT82%2FTwinkleDhamecha-Photo-6HgbxPB5LxEu.jpg&w=1920&q=75',
            },
          ].map((item, index) => (
            <Flex
              key={index}
              flexDir={{ xs: 'column', sm: 'row', md: 'column' }}
              columnGap="20px"
              rowGap="16px"
            >
              <Flex
                flexDir="column"
                alignItems={{ xs: 'center', sm: 'flex-start' }}
                rowGap="8px"
              >
                <Box boxSize="95px" borderRadius="50%" overflow="hidden">
                  <Avatar
                    name={item.name}
                    w="100%"
                    h="100%"
                    src={item.image}
                    objectFit="cover"
                  />
                </Box>
                <Flex flexDir="column" rowGap="4px">
                  <Heading
                    variant="blogQuestion"
                    textAlign={{ xs: 'center', sm: 'left' }}
                  >
                    {item.name}
                  </Heading>
                  <Text
                    variant="blogAnswer"
                    textAlign={{ xs: 'center', sm: 'left' }}
                    fontStyle="italic"
                  >
                    {item.position}
                  </Text>
                </Flex>
              </Flex>
            </Flex>
          ))}
        </Flex>

        <Box w={{ xs: '100%', md: '73%' }}>
          <Text variant="blogAnswer" mb="20px">
            The International Monetary Fund continues to be optimistic about
            India&apos;s economic prospects, raising its GDP growth forecast for
            FY 2024-25 to 7%. High-net-worth individuals, accredited investors,
            and institutional investors—including banks, insurance companies,
            and development finance institutions—can access a diverse range of
            products in the form of SEBI-regulated AIFs, tailored to their
            specific investment goals and risk appetites. Indian fund managers
            continue to innovate, introducing new AIF strategies that provide
            such investors, both Indian and foreign, with opportunities to
            participate in India&apos;s growing economy.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            Since their inception in 2012, AIFs have experienced significant
            growth and evolution as an asset class. Indian AIF managers have
            garnered over INR 11.7 lakh crore in cumulative commitments. SEBI
            has strived to maintain a delicate balance between fostering AIF
            growth and ensuring regulatory compliance.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            The past few years have witnessed a surge in regulatory activity
            surrounding AIFs with SEBI implementing several measures to ensure
            that enhanced governance norms are adopted by AIFs. These range from
            introducing a standardised format for PPMs, to the addition of
            another layer of scrutiny through the appointment of a merchant
            banker to sign-off on the disclosures under the PPM, issuance of
            detailed valuation guidelines for AIFs, and more recently, the
            issuance of guidelines around specific due diligence checks to be
            implemented by AIFs to prevent facilitation of circumvention of
            other regulatory frameworks.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            The recent amendments notifying specific due diligence requirements
            for AIFs in certain scenarios seem to be designed to prevent the
            misuse of AIFs for regulatory arbitrage. This includes instances
            where a single investor or an &quot;investor group&quot; forms an
            AIF solely to achieve &quot;qualified buyer&quot; or &quot;qualified
            institutional buyer&quot; status when they may not independently
            qualify as such. Additionally, AIFs with RBI-regulated entities as
            managers/sponsors or as significant investors or as associates of
            the manager/sponsor who are investing in the AIF or where such
            RBI-regulated entities by itself, or through its
            representative(s)/nominee(s), has majority or veto power in voting
            over decisions of the investment committee are subject to enhanced
            scrutiny to address concerns about evergreening of stressed loans
            and prevent circumvention of RBI&apos;s regulations. Lastly, given
            that Foreign Direct Investment (FDI) from persons resident in
            countries sharing a land border with India or where the beneficial
            owner of an investment into India is situated in or is a citizen of
            any such country, has been subject to government approval since
            Press Note 3 of 2020 issued by Department for Promotion of Industry
            and Internal Trade, SEBI has also prescribed enhanced diligence
            measures for AIFs with majority investment from such investors.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            Before judging SEBI to be a harsh regulator, fund managers should be
            mindful of SEBI’s philosophy behind such increased scrutiny. SEBI is
            of the view that the enhanced trust that would result from adherence
            to such obligations, underlying principles, and implementation
            standards, along with verification of the adherence, would provide
            regulatory comfort for introduction of other Ease of Doing Business
            proposals/measures relating to AIFs and obviate the need for
            granular regulations. Among the other notable regulatory changes
            introduced last year, SEBI has mandated that at least one member of
            the investment manager&apos;s key team must possess the NISM
            Series-XIX-C: Alternative Investment Fund Managers Certification, in
            addition to a relevant professional qualification. This NISM
            certification requirement replaced the previous requirement of 5
            years of professional experience in advising or managing capital
            pools. This change is expected to encourage first-time fund managers
            to enter the AIF space. Additionally, SEBI finally established a
            clear framework for AIFs and Venture Capital Funds (VCFs) set-up in
            the regulatory regime that preceded AIFs to deal with unliquidated
            investments at the end of their tenure. This has been an issue
            plaguing AIFs and particularly VCFs for a while, and especially in
            light of delays to exits caused due to COVID. This framework
            includes the option of extending the tenure through a
            &quot;dissolution period,&quot; or making mandatory in-specie
            distributions, and provides greater flexibility for fund managers to
            address the issue of unliquidated investments within the prescribed
            framework. In addition to the growth of domestic AIFs, the last few
            years has also seen the emergence of GIFT City as a prominent
            international financial services hub, attracting numerous fund
            managers seeking to cater to both Indian and foreign investors. Its
            ranking has climbed from 67 to 57 in the Global Financial Centres
            Index 2024, reflecting its growing appeal. The Hon’ble Minister of
            Finance and Corporate Affairs, Ms. Sitharaman, has highlighted GIFT
            City&apos;s importance in India&apos;s vision to become a developed
            nation by 2047.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            The Government’s intent to promote GIFT City is evident by
            amendments by SEBI to the SEBI (Foreign Portfolio Investors)
            Regulations, 2019 allowing up to 100% aggregate participation by
            non-resident Indians, overseas citizen of Indias and resident Indian
            individuals in FPIs based out of GIFT City, along with the
            introduction of IFSCA&apos;s Single Window IT System (SWIT System),
            have further enhanced GIFT City&apos;s attractiveness. The SWIT
            System should go a long way facilitating ease of doing business by
            streamlining the application process and bringing together various
            government agencies and regulators on a single digital platform.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            The Union Budget 2024-2025 envisages the introduction of Variable
            Capital Company (VCC) structures in GIFT City. VCCs, a globally
            recognized investment vehicle, are particularly prevalent in
            Singapore and offer several advantages. By setting up VCCs in GIFT
            City, fund managers can manage multiple funds with diverse
            investment strategies and cater to investors with varying risk
            profiles within a single structure, positioning GIFT City as a
            competitive alternative to Singapore given India’s good standing and
            track record of compliance with international Know-Your-Customer
            (KYC) and Prevention of Money Laundering (PMLA) norms. Furthermore,
            the recently introduced IFSC (Listing) Regulations, 2024, which
            enable the direct listing of securities and financial products on
            IFSC stock exchanges, should enhance GIFT City&apos;s attractiveness
            for capital raising.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            In conclusion, the future of AIFs as an asset class appears
            promising. Recent developments in the industry have fostered a
            balanced regulatory environment that offers flexibility to fund
            managers while ensuring investor confidence. The availability of
            ample capital and strong regulatory support bode well for the
            continued growth and success of AIFs in India as well as GIFT City,
            it appears that they are poised to play an important role in the
            India growth story.
          </Text>
        </Box>
      </Flex>
      <Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
      <Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
        <Heading variant="blogQuestion" fontStyle="normal" as="span">
          #TheContext by IVCA{' '}
        </Heading>
        – features opinion makers from the alternate investing industry with
        strong focus on India as investment destination. Watch this space for
        viewpoints on investment themes, emerging trends, economic analysis and
        latest industry insights.
      </Text>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        Content in this section is curated by team IVCA. To share feedback,
        connect with &nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default TheAlternativeInvestmentContext;
